import { motion } from "framer-motion";
import { Bike } from "lucide-react";
import { DELIVERY_LINKS } from "../data";

const PLATFORMS = [
  { id: "didi", label: "DiDi Food", href: DELIVERY_LINKS.didi, className: "bg-[#FF7A00] text-white hover:brightness-110" },
  { id: "rappi", label: "Rappi", href: DELIVERY_LINKS.rappi, className: "bg-[#FF3008] text-white hover:brightness-110" },
  { id: "uber", label: "Uber Eats", href: DELIVERY_LINKS.uber, className: "bg-[#06C167] text-white hover:brightness-110" },
];

export const PlatformsSocial = () => {
  return (
    <section
      id="plataformas"
      data-testid="platforms-social-section"
      className="relative py-10 md:py-12 bg-[#FBF5EA]"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.55 }}
          className="bg-brand-burgundy rounded-2xl border border-brand-gold/30 px-6 py-6 md:px-8 md:py-7 flex flex-col md:flex-row md:items-center md:justify-between gap-5"
        >
          <div className="md:max-w-xl">
            <p className="text-brand-gold uppercase tracking-[0.3em] text-[11px] mb-1.5">
              También nos encuentras en
            </p>
            <h2 className="font-display text-2xl font-bold text-brand-cream leading-tight">
              Pide por tus apps favoritas
            </h2>
            <p className="mt-2 text-sm text-brand-sand leading-relaxed">
              La Herencia Castañón también está disponible en{" "}
              <span className="text-brand-gold font-semibold">DiDi Food</span>,{" "}
              <span className="text-brand-gold font-semibold">Rappi</span> y{" "}
              <span className="text-brand-gold font-semibold">Uber Eats</span>.
              Búscanos por nuestro nombre en tu app de entrega.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0">
            {PLATFORMS.map((p) => {
              const Tag = p.href ? "a" : "span";
              return (
                <Tag
                  key={p.id}
                  {...(p.href
                    ? { href: p.href, target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  data-testid={`platform-${p.id}`}
                  className={`inline-flex items-center gap-2 text-sm font-bold px-4 py-2.5 rounded-full transition-all ${p.className} ${
                    p.href ? "" : "opacity-90 cursor-default"
                  }`}
                >
                  <Bike className="w-4 h-4" /> {p.label}
                </Tag>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
